import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class EncryptedZipService {

  private path = "/encrypted-zip"

  constructor(private backendService:BackendService) { }

   
}
